export default __webpack_public_path__ + "static/media/logoNmk_blue.abff6910.png";